import { render, staticRenderFns } from "./CancelPermissionButton.vue?vue&type=template&id=154b9f7d"
import script from "./CancelPermissionButton.vue?vue&type=script&lang=js"
export * from "./CancelPermissionButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports